import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { getStripe } from "@/lib/stripe";

interface StripeEmbeddedCheckoutProps {
  clientSecret: string;
}

const StripeEmbeddedCheckout = ({ clientSecret }: StripeEmbeddedCheckoutProps) => {
  const options = { fetchClientSecret: () => Promise.resolve(clientSecret) };

  return (
    <div id="checkout" className="w-full">
      <EmbeddedCheckoutProvider stripe={getStripe()} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default StripeEmbeddedCheckout;
